import styled, { createGlobalStyle } from "styled-components";

import { TOUR_THEME_CLASS } from "constants/tourGuiado";

// ---- botão + menu de ajuda (reutilizável em qualquer tela) ----------------
export const HelpWrap = styled.div`
  position: relative;
  flex: none;
`;

export const HelpBtn = styled.button`
  display: flex;
  align-items: center;
  gap: 6px;
  height: 30px;
  padding: 0 12px 0 8px;
  border-radius: 15px;
  border: 1.5px solid #7367f0;
  background: #efedfd;
  color: #5e50ee;
  font-size: 12px;
  font-weight: 800;
  cursor: pointer;
  white-space: nowrap;

  &:hover {
    background: #7367f0;
    color: #fff;
  }

  span {
    display: flex;
    align-items: center;
    justify-content: center;
    width: 18px;
    height: 18px;
    border-radius: 50%;
    background: #7367f0;
    color: #fff;
    font-size: 11px;
    font-weight: 800;
  }
  &:hover span {
    background: #fff;
    color: #7367f0;
  }
`;

export const HelpTooltip = styled.div`
  position: absolute;
  right: 0;
  top: 36px;
  z-index: 29;
  width: 220px;
  padding: 9px 11px;
  border-radius: 9px;
  background: #1f2b4d;
  color: #fff;
  font-size: 11px;
  font-weight: 600;
  line-height: 1.45;
  opacity: 0;
  pointer-events: none;
  transition: opacity 0.15s ease;

  ${HelpBtn}:hover ~ & {
    opacity: 1;
  }
`;

export const HelpMenu = styled.div`
  position: absolute;
  right: 0;
  top: 36px;
  z-index: 30;
  width: 240px;
  padding: 8px;
  background: #fff;
  border: 1px solid #eceef5;
  border-radius: 12px;
  box-shadow: 0 10px 30px rgba(31, 43, 77, 0.14);
`;

export const HelpMenuTitulo = styled.div`
  font-size: 9px;
  font-weight: 800;
  letter-spacing: 0.8px;
  text-transform: uppercase;
  color: #a9b0c2;
  padding: 4px 8px 6px;
`;

export const HelpTour = styled.button`
  width: 100%;
  text-align: left;
  padding: 8px 10px;
  margin-bottom: 4px;
  border: none;
  border-radius: 8px;
  background: #7367f0;
  color: #fff;
  font-size: 12px;
  font-weight: 700;
  cursor: pointer;
`;

export const HelpItem = styled.button`
  width: 100%;
  text-align: left;
  padding: 7px 10px;
  border: none;
  border-radius: 8px;
  background: transparent;
  color: #3d4457;
  font-size: 11.5px;
  font-weight: 600;
  cursor: pointer;

  &:hover {
    background: #f6f5fe;
    color: #5e50ee;
  }
`;

// Tema do Shepherd (roxo Vuexy) — classe compartilhada (TOUR_THEME_CLASS), com
// especificidade alta para vencer o CSS padrão do Shepherd (que pinta o header
// de cinza e deixaria o título branco ilegível). Injetado uma vez.
export const ShepherdTheme = createGlobalStyle`
  .shepherd-element.${TOUR_THEME_CLASS} {
    border-radius: 12px;
    box-shadow: 0 12px 34px rgba(31,43,77,.24);
    max-width: 340px;
    background: #fff;
  }
  .shepherd-element.${TOUR_THEME_CLASS} .shepherd-content .shepherd-header {
    background: #7367f0;
    padding: 12px 14px;
    border-top-left-radius: 12px;
    border-top-right-radius: 12px;
  }
  .shepherd-element.${TOUR_THEME_CLASS} .shepherd-content .shepherd-header .shepherd-title {
    color: #ffffff;
    font-size: 13.5px;
    font-weight: 800;
  }
  .shepherd-element.${TOUR_THEME_CLASS} .shepherd-cancel-icon {
    color: #ffffff;
    opacity: 0.9;
  }
  .shepherd-element.${TOUR_THEME_CLASS} .shepherd-text {
    padding: 13px 14px;
    font-size: 12.5px;
    line-height: 1.55;
    color: #2c3348;
    background: #fff;
  }
  .shepherd-element.${TOUR_THEME_CLASS} .shepherd-text b { color: #1f2b4d; }
  .shepherd-element.${TOUR_THEME_CLASS} .shepherd-footer { padding: 0 14px 13px; gap: 8px; }
  .shepherd-element.${TOUR_THEME_CLASS} .shepherd-footer .shepherd-button {
    background: #7367f0;
    color: #fff;
    border-radius: 7px;
    font-size: 12px;
    font-weight: 700;
    padding: 7px 14px;
  }
  .shepherd-element.${TOUR_THEME_CLASS} .shepherd-footer .shepherd-button.shepherd-button-secondary {
    background: #eceef5;
    color: #5c6478;
  }
`;
